// komponent wizualizujący dostępność produktu

import React, { FC } from 'react';
import classnames from 'classnames';
import DOMPurify from 'isomorphic-dompurify';
import { BoxSeam } from 'react-bootstrap-icons';

import { IStock } from 'api/types';

import styles from 'theme/components/controls/Availability/Availability.module.scss';

// typ danych wejściowych
interface IProps {
  stock: IStock;
}

const Availability: FC<IProps> = ({ stock }) => {
  const label =
    typeof stock.name === 'string' ? (
      <span
        className={styles.label}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(stock.name) }}
      />
    ) : (
      <span className={styles.label}>{stock.name}</span>
    );

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        styles[stock.type],
        'StylePath-Components-Controls-Availability'
      )}>
      <BoxSeam />
      {label}
    </div>
  );
};

export default Availability;
